import { render, staticRenderFns } from "./sliderScreening.vue?vue&type=template&id=518946d8"
import script from "./sliderScreening.vue?vue&type=script&lang=js"
export * from "./sliderScreening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports